<template>
  <div>
    <page-component style="position: relative" :loading="loading">
      <template #content>
        <v-sheet class="px-5 py-4 request-log-page" style="margin-top: 10px">
          <div class="request-log-page__actions"
            v-if="!isExternalLogPage && hasOtherRequestGroups && requestGroups.length > 1"
            style="display: flex; justify-content: flex-end; margin-bottom: 16px">
            <v-btn small color="primary" @click="openExternalLogPage">
              <v-icon left small>mdi-file-document-multiple</v-icon>
              عرض السجلات المتصلة
            </v-btn>
          </div>
          <!-- request log inside request details page itself-->
          <div v-if="!isExternalLogPage || requestGroups.length === 1">
            <div v-if="!currentRequestHistory.length && !loading" class="request-log-page__empty">
              <v-alert color="blue" dense outlined type="info">
                لا توجد بيانات في <strong>سجل الطلب</strong>
              </v-alert>
            </div>

            <div v-else class="supportContainer">
              <div class="request-log-timeline">
                <div v-for="(item, logIndex) in currentRequestHistory" :key="`${currentRequestId}-${logIndex}`">
                  <div class="lightArrow" v-if="logIndex % 2 === 0">
                    <div :style="`border-color:${returnColor(item)}`" style="text-align: end; width: 371px"
                      class="dateContainer"></div>
                    <div class="request-log-timeline__line">
                      <div :style="`background:${returnColor(item)}`" class="request-log-timeline__icon">
                        <OrderIcons :item="item" />
                      </div>
                    </div>
                    <div style="width: 42px; display: flex; justify-content: end">
                      <div class="side__arrow" :style="`border-left:8px solid ${returnColor(item)}; margin-lef: 4px`">
                      </div>
                    </div>
                    <div class="leftBox" :style="`border-color:${returnColor(item)}`">
                      <div style="display: flex; justify-content: space-between">
                        <div class="customerName" style="font-size: 14px; color: #3f0e40">
                          {{ getLogTitle(item) }} -
                          <button v-if="getLogTitle(item).includes('أضافة تذكرة برقم')" class="mobile-link"
                            type="button" @click="to_task_content(getLogTitle(item).match(/\b\d+\b/g))">
                            التذكرة
                          </button>
                          <button v-if="getLogTitle(item).includes('طلب دعم فني')" class="mobile-link" type="button"
                            @click="to_supportRequest_details(getLogTitle(item).match(/\b\d+\b/g))">
                            فتح طلب الدعم
                          </button>
                          <button v-if="getLogTitle(item).includes('مكالمة جديدة برقم')" class="mobile-link"
                            type="button" @click="to_call_voice(getLogTitle(item).match(/\b\d+\b/g))">
                            فتح المكالمة
                          </button>
                        </div>


                        <div class="request-log-timeline__date">
                          {{ formatLogDate(item.raw_date) }}
                        </div>
                      </div>


                      <v-tooltip bottom color="#451646">
                        <template v-slot:activator="{ on }">
                          <v-card-text v-if="!isCallLog(item)" v-on="on" class="pb-0 pt-0 px-0" style="font-size: 14px">
                            {{ getLogValuePreview(item) }}
                          </v-card-text>
                          <audio v-else controls>
                            <source :src="item.value" type="audio/ogg" />
                            Your browser does not support the audio element.
                          </audio>
                        </template>
                        <div style="font-size: 14px">{{ item.value }}</div>
                      </v-tooltip>

                      <!-- =================================================================== -->
                      <MergedRequestBtn :item="item" :showButton="getLogTitle(item).includes('دمج الطلب')"
                        @view-merged="viewMergedRequest" />
                      <!-- =================================================================== -->

                    </div>
                  </div>

                  <div class="darkArrow" v-else>
                    <div class="leftBox" :style="`border-color:${returnColor(item)}`">
                      <div class="customerName">
                        <div style="display: flex; justify-content: space-between">
                          <div class="customerName" style="font-size: 14px; color: #3f0e40">
                            {{ getLogTitle(item) }}
                            <button v-if="getLogTitle(item).includes('أضافة تذكرة برقم')" class="mobile-link"
                              type="button" @click="to_task_content(getLogTitle(item).match(/\b\d+\b/g))">
                              التذكرة
                            </button>
                            <button v-if="getLogTitle(item).includes('طلب دعم فني')" class="mobile-link" type="button"
                              @click="to_supportRequest_details(getLogTitle(item).match(/\b\d+\b/g))">
                              فتح طلب الدعم
                            </button>
                            <button v-if="getLogTitle(item).includes('مكالمة جديدة برقم')" class="mobile-link"
                              type="button" @click="to_call_voice(getLogTitle(item).match(/\b\d+\b/g))">
                              فتح المكالمة
                            </button>
                          </div>
                          <div class="request-log-timeline__date">
                            {{ formatLogDate(item.raw_date) }}
                          </div>
                        </div>

                      </div>

                      <v-tooltip bottom color="#451646">
                        <template v-slot:activator="{ on }">
                          <v-card-text v-if="!isCallLog(item)" v-on="on" class="pb-0 pt-0 px-0"
                            style="font-size: 14px; margin-top: -4px">
                            {{ getLogValuePreview(item) }}
                          </v-card-text>
                          <audio v-else controls>
                            <source :src="item.value" type="audio/ogg" />
                            Your browser does not support the audio element.
                          </audio>
                        </template>
                        <div style="font-size: 14px">{{ item.value }}</div>
                      </v-tooltip>

                      <!-- =================================================================== -->
                      <MergedRequestBtn :item="item" :showButton="getLogTitle(item).includes('دمج الطلب')"
                        @view-merged="viewMergedRequest" />
                      <!-- =================================================================== -->



                    </div>
                    <div style="width: 42px; display: flex; justify-content: start">
                      <div class="side__arrow" style="margin-right: -4px"
                        :style="`border-right:8px solid ${returnColor(item)}`"></div>
                    </div>
                    <div class="request-log-timeline__line">
                      <div :style="`background:${returnColor(item)}`" class="request-log-timeline__icon">
                        <OrderIcons :item="item" />
                      </div>
                    </div>
                    <div class="dateContainer" style="width: 371px"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <v-expansion-panels v-model="expandedPanel" accordion flat class="request-log-accordion">
              <v-expansion-panel v-for="group in requestGroups" :key="group.request_id"
                class="request-log-accordion__panel">
                <v-expansion-panel-header class="request-log-accordion__header">
                  <div class="request-log-accordion__header-content">
                    <span class="request-log-accordion__title">
                      طلب #{{ group.request_id }}
                      <v-chip v-if="isCurrentRequest(group.request_id)" x-small color="#451646" text-color="white"
                        class="mr-2">
                        الحالي
                      </v-chip>
                    </span>
                    <span class="request-log-accordion__meta">
                      {{ group.history.length }}
                      {{ group.history.length === 1 ? "سجل" : "سجلات" }}
                    </span>
                  </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="request-log-accordion__body">
                  <div v-if="!group.history.length" class="py-3">
                    <v-alert dense outlined type="info" color="blue">
                      لا توجد سجلات لهذا الطلب
                    </v-alert>
                  </div>

                  <div v-else class="supportContainer">
                    <div class="request-log-timeline">
                      <div v-for="(item, logIndex) in group.history" :key="`${group.request_id}-${logIndex}`">
                        <!-- Left side timeline row -->
                        <div class="lightArrow" v-if="logIndex % 2 === 0">
                          <div :style="`border-color:${returnColor(item)}`" style="text-align: end; width: 371px"
                            class="dateContainer"></div>
                          <div class="request-log-timeline__line">
                            <div :style="`background:${returnColor(item)}`" class="request-log-timeline__icon">
                              <OrderIcons :item="item" />
                            </div>
                          </div>
                          <div style="width: 42px; display: flex; justify-content: end">
                            <div class="side__arrow"
                              :style="`border-left:8px solid ${returnColor(item)}; margin-lef: 4px`"></div>
                          </div>
                          <div class="leftBox" :style="`border-color:${returnColor(item)}`">
                            <div style="display: flex; justify-content: space-between">
                              <div class="customerName" style="font-size: 14px; color: #3f0e40">
                                {{ getLogTitle(item) }}
                                <button v-if="getLogTitle(item).includes('أضافة تذكرة برقم')" class="mobile-link"
                                  type="button" @click="to_task_content(getLogTitle(item).match(/\b\d+\b/g))">
                                  التذكرة
                                </button>
                                <button v-if="getLogTitle(item).includes('طلب دعم فني')" class="mobile-link"
                                  type="button" @click="to_supportRequest_details(getLogTitle(item).match(/\b\d+\b/g))">
                                  فتح طلب الدعم
                                </button>
                                <button v-if="getLogTitle(item).includes('مكالمة جديدة برقم')" class="mobile-link"
                                  type="button" @click="to_call_voice(getLogTitle(item).match(/\b\d+\b/g))">
                                  فتح المكالمة
                                </button>
                              </div>
                              <div class="request-log-timeline__date">
                                {{ formatLogDate(item.raw_date) }}
                              </div>
                            </div>
                            <v-tooltip bottom color="#451646">
                              <template v-slot:activator="{ on }">
                                <v-card-text v-if="!isCallLog(item)" v-on="on" class="pb-0 pt-0 px-0"
                                  style="font-size: 14px">
                                  {{ getLogValuePreview(item) }}
                                </v-card-text>
                                <audio v-else controls>
                                  <source :src="item.value" type="audio/ogg" />
                                  Your browser does not support the audio element.
                                </audio>
                              </template>
                              <div style="font-size: 14px">{{ item.value }}</div>
                            </v-tooltip>

                            <!-- =================================================================== -->
                            <MergedRequestBtn :item="item" :showButton="getLogTitle(item).includes('دمج الطلب')"
                              @view-merged="viewMergedRequest" />
                            <!-- =================================================================== -->


                          </div>
                        </div>

                        <!-- Right side timeline row -->
                        <div class="darkArrow" v-else>
                          <div class="leftBox" :style="`border-color:${returnColor(item)}`">
                            <div class="customerName">
                              <div style="display: flex; justify-content: space-between">
                                <div class="customerName" style="font-size: 14px; color: #3f0e40">
                                  {{ getLogTitle(item) }}
                                  <button v-if="getLogTitle(item).includes('أضافة تذكرة برقم')" class="mobile-link"
                                    type="button" @click="to_task_content(getLogTitle(item).match(/\b\d+\b/g))">
                                    التذكرة
                                  </button>
                                  <button v-if="getLogTitle(item).includes('طلب دعم فني')" class="mobile-link"
                                    type="button"
                                    @click="to_supportRequest_details(getLogTitle(item).match(/\b\d+\b/g))">
                                    فتح طلب الدعم
                                  </button>
                                  <button v-if="getLogTitle(item).includes('مكالمة جديدة برقم')" class="mobile-link"
                                    type="button" @click="to_call_voice(getLogTitle(item).match(/\b\d+\b/g))">
                                    فتح المكالمة
                                  </button>
                                </div>
                                <div class="request-log-timeline__date">
                                  {{ formatLogDate(item.raw_date) }}
                                </div>
                              </div>
                            </div>
                            <v-tooltip bottom color="#451646">
                              <template v-slot:activator="{ on }">
                                <v-card-text v-if="!isCallLog(item)" v-on="on" class="pb-0 pt-0 px-0"
                                  style="font-size: 14px; margin-top: -4px">
                                  {{ getLogValuePreview(item) }}
                                </v-card-text>
                                <audio v-else controls>
                                  <source :src="item.value" type="audio/ogg" />
                                  Your browser does not support the audio element.
                                </audio>
                              </template>
                              <div style="font-size: 14px">{{ item.value }}</div>
                            </v-tooltip>

                            <!-- =================================================================== -->
                            <MergedRequestBtn :item="item" :showButton="getLogTitle(item).includes('دمج الطلب')"
                              @view-merged="viewMergedRequest" />
                            <!-- =================================================================== -->



                          </div>
                          <div style="width: 42px; display: flex; justify-content: start">
                            <div class="side__arrow" style="margin-right: -4px"
                              :style="`border-right:8px solid ${returnColor(item)}`"></div>
                          </div>
                          <div class="request-log-timeline__line">
                            <div :style="`background:${returnColor(item)}`" class="request-log-timeline__icon">
                              <OrderIcons :item="item" />
                            </div>
                          </div>
                          <div class="dateContainer" style="width: 371px"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-sheet>
      </template>
    </page-component>

    <!-- ========================================================================= -->
    <v-dialog v-model="showMergedHistoryDialog" max-width="750px" persistent>
      <v-card>
        <v-toolbar flat color="#451646" dark>
          <v-toolbar-title>سجل الطلب المدمج #{{ mergedRequestHistoryRequestId }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="showMergedHistoryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <div v-if="mergedRequestHistoryLoading" class="text-center py-6">
            <v-progress-circular indeterminate color="primary" />
          </div>

          <div v-else>
            <div v-if="!mergedRequestHistory.length" class="py-4">
              <v-alert dense outlined type="info">
                لا توجد سجلات لعرضها لهذا الطلب.
              </v-alert>
            </div>

            <div v-else class="supportContainer">
              <div class="request-log-timeline">
                <div v-for="(item, index) in mergedRequestHistory"
                  :key="`merged-history-${mergedRequestHistoryRequestId}-${index}`">
                  <div class="lightArrow" v-if="index % 2 === 0">
                    <div :style="`border-color:${returnColor(item)}`" style="text-align: end; width: 371px"
                      class="dateContainer"></div>
                    <div class="request-log-timeline__line">
                      <div :style="`background:${returnColor(item)}`" class="request-log-timeline__icon">
                        <OrderIcons :item="item" />
                      </div>
                    </div>
                    <div style="width: 42px; display: flex; justify-content: end">
                      <div class="side__arrow" :style="`border-left:8px solid ${returnColor(item)}; margin-lef: 4px`">
                      </div>
                    </div>
                    <div class="leftBox" :style="`border-color:${returnColor(item)}`">
                      <div style="display: flex; justify-content: space-between">
                        <div class="customerName" style="font-size: 14px; color: #3f0e40">
                          {{ getLogTitle(item) }}
                        </div>
                        <div class="request-log-timeline__date">
                          {{ formatLogDate(item.raw_date) }}
                        </div>
                      </div>
                      <div style="font-size: 14px; margin-top: 4px">{{ item.value }}</div>
                    </div>
                  </div>

                  <div class="darkArrow" v-else>
                    <div class="leftBox" :style="`border-color:${returnColor(item)}`">
                      <div class="customerName">
                        <div style="display: flex; justify-content: space-between">
                          <div class="customerName" style="font-size: 14px; color: #3f0e40">
                            {{ getLogTitle(item) }}
                          </div>
                          <div class="request-log-timeline__date">
                            {{ formatLogDate(item.raw_date) }}
                          </div>
                        </div>
                      </div>
                      <div style="font-size: 14px; margin-top: 4px">{{ item.value }}</div>
                    </div>
                    <div style="width: 42px; display: flex; justify-content: start">
                      <div class="side__arrow" style="margin-right: -4px"
                        :style="`border-right:8px solid ${returnColor(item)}`"></div>
                    </div>
                    <div class="request-log-timeline__line">
                      <div :style="`background:${returnColor(item)}`" class="request-log-timeline__icon">
                        <OrderIcons :item="item" />
                      </div>
                    </div>
                    <div class="dateContainer" style="width: 371px"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="showMergedHistoryDialog = false">
            إغلاق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ========================================================================= -->

    <OneCallsDialog />
    <OneContentDialog />
    <TasksDetailsDialog v-if="$store.state.TaskDetailsDialog" />
  </div>
</template>

<script>
import Axios from "axios";
import OneCallsDialog from "@/components/Charts/OneCallsDialog.vue";
import OneContentDialog from "@/components/Charts/OneContentDialog.vue";
import TasksDetailsDialog from "./TasksDetailsDialog.vue";
import OrderIcons from "../RequestDetailsForDefaultVue/OrderIcons.vue";
import MergedRequestBtn from "../AdminComponent/MergedRequestBtn.vue";

export default {
  components: { OneCallsDialog, OneContentDialog, TasksDetailsDialog, OrderIcons, MergedRequestBtn },
  props: ["agent"],
  data() {
    return {
      requestGroups: [],
      currentRequestId: null,
      expandedPanel: 0,
      loading: false,
      sources_text: [
        "إضافة الطلب من عطارد",
        "إضافة الطلب من الموقع الإلكتروني",
        "إضافة الطلب من تمويلك",
        "إضافة الطلب من قبل مدير النظام",
        "إضافة الطلب من موقع الحاسبة",
        "طلب مضاف من قبل مدير النظام",
        "إضافة الطلب من واتس اب",
      ],
      currentRole: window.localStorage.getItem("role"),
      showMergedHistoryDialog: false,
      mergedRequestHistory: [],
      mergedRequestHistoryLoading: false,
      mergedRequestHistoryRequestId: null,
    };
  },
  computed: {
    isExternalLogPage() {
      console.log('-------------------------');
      console.log('isExternalLogPage called');
      console.log('this.$route.name', this.$route.name);
      return this.$route.name === "request_log_new_tap";
    },
    currentRequestGroup() {
      return (
        this.requestGroups.find((group) => this.isCurrentRequest(group.request_id)) || {
          request_id: this.currentRequestId,
          history: [],
        }
      );
    },
    currentRequestHistory() {
      return this.currentRequestGroup.history || [];
    },
    hasOtherRequestGroups() {
      console.log('-------------------------');
      console.log('hasOtherRequestGroups called');
      const hasOtherRequestGroups = this.requestGroups.some((group) => !this.isCurrentRequest(group.request_id));
      console.log('hasOtherRequestGroups', hasOtherRequestGroups);
      return hasOtherRequestGroups;
    },
  },
  created() {
    this.get_request_logs();
  },
  methods: {
    // ======================================================
    // view merged request
    // ======================================================
    async viewMergedRequest(item) {
      const deletedRequestId = this.extractMergedRequestId(item.text || item.status || item.value);
      if (!deletedRequestId) {
        this.showPopup('error', 'غير قادر على تحديد رقم الطلب المدمج');
        return;
      }

      this.mergedRequestHistoryRequestId = deletedRequestId;
      this.mergedRequestHistoryLoading = true;
      this.showMergedHistoryDialog = true;

      try {
        const response = await Axios.get(
          `${this.$store.state.url}/v2/employee/Request/History-Deleted/${deletedRequestId}`,
          { headers: this.request_headers() }
        );

        this.mergedRequestHistory = Array.isArray(response.data.payload)
          ? response.data.payload
          : [];
      } catch (err) {
        this.mergedRequestHistory = [];
        this.showPopup(
          'error',
          err.response?.data?.message || 'حدث خطأ أثناء تحميل سجلات الطلب المدمج'
        );
      } finally {
        this.mergedRequestHistoryLoading = false;
      }
    },

    extractMergedRequestId(text) {
      if (!text) {
        return null;
      }

      const matches = String(text).match(/(\d+)/g);
      if (!matches || !matches.length) {
        return null;
      }

      //fetch last number in the text (merged request id)
      return Number(matches[matches.length - 1]);
    },
    // ======================================================
    openExternalLogPage() {
      this.$router.push({
        name: "request_log_new_tap",
        params: { id: this.currentRequestId },
      });
    },
    // Parse grouped API payload (with legacy flat-array fallback)
    parseGroupedHistoryPayload(payload) {
      const fallbackRequestId = Number(this.agent?.id) || null;

      if (payload && Array.isArray(payload.requests)) {
        const currentRequestId = Number(payload.current_request_id) || fallbackRequestId;

        return {
          currentRequestId: currentRequestId,
          groups: payload.requests.map((group) => ({
            request_id: Number(group.request_id),
            history: Array.isArray(group.history) ? group.history : [],
          })),
        };
      }

      if (Array.isArray(payload)) {
        return {
          currentRequestId: fallbackRequestId,
          groups: fallbackRequestId
            ? [{ request_id: fallbackRequestId, history: payload }]
            : [],
        };
      }

      return { currentRequestId: fallbackRequestId, groups: [] };
    },

    isCurrentRequest(requestId) {
      return Number(requestId) === Number(this.currentRequestId);
    },

    getLogTitle(item) {
      return item?.text || item?.status || "";
    },

    isCallLog(item) {
      return this.getLogTitle(item).includes("مكالمة جديده");
    },

    getLogValuePreview(item) {
      const title = this.getLogTitle(item);
      if (Number(this.currentRole) === 0 && this.sources_text.includes(title)) {
        return "";
      }

      if (!item?.value) {
        return "";
      }

      return item.value.length > 50 ? `${item.value.substring(0, 50)}...` : item.value;
    },

    formatLogDate(rawDate) {
      if (!rawDate) {
        return "";
      }

      const value = String(rawDate);
      const [datePart, timePart = ""] = value.split("T");

      if (!timePart) {
        return datePart;
      }

      return `${datePart} - ${timePart.split(".")[0]}`;
    },

    returnColor(item) {
      if (
        item.english_status === "sended_request" ||
        item.english_status === "created_request" ||
        item.english_status === "completed_request"
      ) {
        return "#25D366";
      }

      if (
        item.english_status === "rejected_request" ||
        item.english_status === "moved_request"
      ) {
        return "#EE0000";
      }

      if (item.english_status === "agent_notes") {
        return "#E5B5E5";
      }

      if (item.english_status === "sarvice_rating") {
        return "#FF9A6C";
      }

      if (item.english_status === "pulled_request") {
        return "#E00";
      }

      if (item.english_status === "duplicated_request") {
        return "#047D87";
      }

      if (item.english_status === "ask_for_real_estate") {
        return "#DBB622";
      }

      return "#3F0E40";
    },

    to_supportRequest_details(requestId) {
      this.$store.state.orderRequestDialog = false;
      this.$router.push({
        name: "help_desk",
        params: { id: requestId[0] },
      });
    },

    to_call_voice(callId) {
      this.$store.state.idOfOneCall = callId;
      this.$store.state.openOneCallDialog = true;
    },

    to_task_content(taskId) {
      this.$store.state.idOfOneTaskContent = taskId;
      this.$store.state.openOneTaskContent = true;
    },

    get_request_logs() {
      if (!this.agent?.id) {
        return;
      }

      this.loading = true;

      Axios.get(
        `${this.$store.state.url}/agent/Request/History-With-Notes/${this.agent.id}`,
        { headers: this.request_headers() }
      )
        .then((response) => {
          const parsed = this.parseGroupedHistoryPayload(response.data.payload);

          this.currentRequestId = parsed.currentRequestId;
          this.requestGroups = parsed.groups;

          // Expand only the current request panel
          const currentIndex = this.requestGroups.findIndex((group) =>
            this.isCurrentRequest(group.request_id)
          );
          this.expandedPanel = this.isExternalLogPage
            ? null
            : currentIndex >= 0
              ? currentIndex
              : 0;

          console.log(
            "[RequestLog] loaded",
            this.requestGroups.length,
            "request group(s), current:",
            this.currentRequestId
          );

          if (this.agent?.customer?.name) {
            this.setBreadCrumbs(["الرئيسية", "الطلبات", this.agent.customer.name]);
          }
        })
        .catch((err) => {
          console.log("[RequestLog] fetch error", err?.response?.data?.message || err.message);
          this.showPopup("error", err.response?.data?.message || "حدث خطأ أثناء تحميل السجل");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    agent_data: {
      handler(val) {
        if (!val?.customer) {
          return;
        }

        val.source = parseInt(val.source);
        val.customer.work = parseInt(val.customer.work);
        this.setBreadCrumbs(["الرئيسية", "الطلبات", val.customer.name]);
      },
    },
    "agent.id"(newId, oldId) {
      if (newId && newId !== oldId) {
        this.get_request_logs();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.request-log-accordion {
  border: 1px solid #ebe5ec;
  border-radius: 12px;
  overflow: hidden;
}

.request-log-accordion__panel {
  border-bottom: 1px solid #ebe5ec;

  &:last-child {
    border-bottom: none;
  }
}

.request-log-accordion__header {
  min-height: 56px !important;
  background: #faf8fb;
}

.request-log-accordion__header-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.request-log-accordion__title {
  font-size: 15px;
  font-weight: 700;
  color: #3f0e40;
}

.request-log-accordion__meta {
  font-size: 12px;
  color: #7a7a7a;
  white-space: nowrap;
}

.request-log-accordion__body {
  background: #fff;
  padding-top: 8px;
}
</style>

<style lang="scss">
.request-log-timeline {
  margin-bottom: 24px;
}

.request-log-timeline__line {
  height: 79px;
  border: 1px dashed #e1d9e1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.request-log-timeline__icon {
  width: 40px;
  height: 40px;
  position: absolute;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 4px;
}

.request-log-timeline__date {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: #a4a3a3;
  white-space: nowrap;
}

.leftBox {
  width: 329px;
  height: unset;
  border: 1px solid #714d72;
  padding: 10px;
  overflow: hidden;
  overflow-y: auto;
  border-radius: 8px;
}

.side__arrow {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  transform: translateX(-50%);
  margin-left: 4px;
}

.lightArrow,
.darkArrow {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.customerName {
  font-weight: bold;
  padding-bottom: 5px;
}

.dateContainer {
  width: 401px;
  padding: 15px;
  color: #666666;
  font-size: 16px;
}
</style>
